(function () {
  if (window.__qlfBundleBuilderLoaded) {
    return;
  }

  window.__qlfBundleBuilderLoaded = true;
  const builderRefreshJobs = new WeakMap();
  const bundleViewTrackCache = new Set();

  function initializeAll(context) {
    const scope = context instanceof HTMLElement ? context : document;
    scope.querySelectorAll('.qlf-bundle-builder').forEach(function (builder) {
      prepareBuilder(builder).catch(function (error) {
        console.warn('[Bundle] Builder refresh failed:', error);
        initializeBuilder(builder);
      });
    });
  }

  function prepareBuilder(builder) {
    if (!builder) {
      return Promise.resolve(null);
    }

    if (builder.dataset.builderReady === 'true') {
      initializeBuilder(builder);
      return Promise.resolve(builder);
    }

    const existingJob = builderRefreshJobs.get(builder);
    if (existingJob) {
      return existingJob;
    }

    const job = refreshBuilderMarkup(builder)
      .catch(function () {
        return builder;
      })
      .then(function (resolvedBuilder) {
        const nextBuilder = resolvedBuilder || builder;
        nextBuilder.dataset.builderReady = 'true';
        initializeBuilder(nextBuilder);
        builderRefreshJobs.delete(builder);
        return nextBuilder;
      });

    builderRefreshJobs.set(builder, job);
    return job;
  }

  function initializeBuilder(root) {
    if (!root || root.dataset.initialized === 'true') {
      return;
    }

    root.dataset.initialized = 'true';

    const parentVariantId = Number(root.dataset.parentVariantId || '0');
    const submitButton = root.querySelector('[data-submit]');

    if (!parentVariantId || !submitButton) {
      return;
    }

    const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
    const labels = {
      button: submitButtonText
        ? submitButtonText.textContent.trim() || 'In den Warenkorb'
        : 'In den Warenkorb',
      incomplete: 'Bitte Varianten auswählen',
      soldOut: 'Ausverkauft'
    };
    const parentVariantAvailable = root.dataset.parentVariantAvailable === 'true';
    const hasBlockedGroups = root.dataset.hasBlockedGroups === 'true';
    const offerId = (root.dataset.offerId || '').trim();
    const bundleName = (root.dataset.bundleName || '').trim();
    const bundleImage = (root.dataset.bundleImage || '').trim();
    const bundlePrice = (root.dataset.bundlePrice || '').trim();
    const bundleCompareAtPrice = (root.dataset.bundleCompareAtPrice || '').trim();
    const allowDuplicates = root.dataset.allowDuplicates !== 'false';
    const discountCode = (root.dataset.discountCode || '').trim();
    const redirectToCart = root.dataset.redirectToCart === 'true';
    const redirectToCheckout = root.dataset.redirectToCheckout === 'true';
    const freeShipping = root.dataset.freeShipping === 'true';
    // Kompaktstring "DE:60.00,AT:80.00": Laender-Schwellen fuer den Gratisversand.
    // Leer heisst "bedingungslos gratis" - dann bleibt die Property weg.
    const freeShippingMin = (root.dataset.freeShippingMin || '').trim();
    const viewTrackingUrl = (root.dataset.viewTrackingUrl || '').trim();
    const viewTrackingDisabled = root.dataset.viewTrackingDisabled === 'true';
    const sectionId = (root.dataset.sectionId || '').trim();
    const slots = Array.from(root.querySelectorAll('.qlf-bundle-builder__slot'));
    const tiered = readTieredConfig(root);
    const incentiveList = tiered ? readIncentiveList(root) : [];
    const componentsInput = tiered ? root.querySelector('[data-bundle-components]') : null;
    const state = {
      submitting: false
    };

    trackBundleView(offerId, viewTrackingUrl, {
      disabled: viewTrackingDisabled
    });

    root.addEventListener('click', function (event) {
      const option = event.target.closest('[data-option]');
      if (option && root.contains(option)) {
        handleOptionSelection(option);
        return;
      }

      const trigger = event.target.closest('[data-trigger]');
      if (trigger && root.contains(trigger)) {
        toggleDropdown(trigger);
      }
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') {
        return;
      }

      closeAllDropdowns(root);
    });

    submitButton.addEventListener('click', addBundleToCart);

    syncAllSlots();

    function handleOptionSelection(option) {
      if (option.getAttribute('aria-disabled') === 'true') {
        return;
      }

      const slot = option.closest('.qlf-bundle-builder__slot');
      const input = getSlotInput(slot);

      if (!slot || !input) {
        return;
      }

      input.value = option.dataset.optionValueId || '';
      closeAllDropdowns(root);
      syncAllSlots();
    }

    function toggleDropdown(trigger) {
      const dropdown = trigger.closest('[data-dropdown]');
      if (!dropdown) {
        return;
      }

      const list = dropdown.querySelector('[data-list]');
      const isOpen = list && list.classList.contains('visible');

      closeAllDropdowns(root, list);

      if (!list) {
        return;
      }

      list.classList.toggle('visible', !isOpen);
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    }

    function syncAllSlots() {
      slots.forEach(updateSlotPresentation);
      updateDuplicateStates();
      updateButtonState();
    }

    function updateSlotPresentation(slot) {
      if (!slot || slot.dataset.staticSlot === 'true') {
        return;
      }

      const input = getSlotInput(slot);
      const selectedId = input ? input.value.trim() : '';
      const triggerLabel = slot.querySelector('[data-trigger-label]');
      const triggerTags = slot.querySelector('[data-trigger-tags]');
      const triggerLabelTag = slot.querySelector('[data-trigger-label-tag]');
      const triggerImage = slot.querySelector('[data-trigger-image]');
      const options = Array.from(slot.querySelectorAll('[data-option]'));
      const defaultLabel = slot.dataset.defaultLabel || 'Bitte wählen';
      const selectedOption = selectedId
        ? options.find((option) => option.dataset.optionValueId === selectedId)
        : null;

      options.forEach((option) => {
        const isSelected = option === selectedOption;
        const optionLabel = option.querySelector('.qlf-select-variant-list-data');

        option.setAttribute('aria-selected', String(isSelected));
        option.classList.toggle('qlf-bg-gray-200', isSelected);

        if (optionLabel) {
          optionLabel.classList.toggle('qlf-font-bold', isSelected);
          optionLabel.classList.toggle('qlf-font-normal', !isSelected);
        }
      });

      if (triggerLabel) {
        triggerLabel.textContent = selectedOption
          ? selectedOption.dataset.optionLabel || defaultLabel
          : defaultLabel;
      }

      if (triggerTags) {
        const optionBadges =
          selectedOption && selectedOption.querySelector('.variant-card-tag--container');
        triggerTags.innerHTML = optionBadges ? optionBadges.outerHTML : '';
      }

      if (triggerImage) {
        const imageUrl = selectedOption && selectedOption.dataset.optionImageUrl;
        const imageAlt = selectedOption && selectedOption.dataset.optionImageAlt;

        if (imageUrl) {
          triggerImage.hidden = false;
          triggerImage.src = imageUrl;
          triggerImage.alt = imageAlt || selectedOption.dataset.optionLabel || '';
        } else {
          triggerImage.hidden = true;
          triggerImage.removeAttribute('src');
          triggerImage.alt = '';
        }
      }

      if (triggerLabelTag) {
        const optionLabelTag =
          selectedOption && selectedOption.querySelector('[data-option-label-tag-template]');
        triggerLabelTag.innerHTML = optionLabelTag ? optionLabelTag.innerHTML : '';
      }

      slot.classList.toggle('qlf-bundle-builder__slot--selected', !!selectedOption);
    }

    function updateDuplicateStates() {
      const selectedVariantIds = getSelectedVariantIds();

      slots.forEach((slot, slotIndex) => {
        const currentValue = getSlotValue(slot);

        slot.querySelectorAll('[data-option]').forEach((option) => {
          const variantId = option.dataset.optionValueId || '';
          const optionSelectable = option.dataset.optionSelectable !== 'false';
          const selectedElsewhere =
            !allowDuplicates &&
            variantId !== '' &&
            selectedVariantIds.some((selectedId, selectedIndex) => {
              return selectedIndex !== slotIndex && selectedId === variantId;
            });
          const shouldDisable =
            !optionSelectable || (selectedElsewhere && variantId !== currentValue);

          option.classList.toggle('qlf-opacity-40', shouldDisable);
          option.classList.toggle('qlf-pointer-events-none', shouldDisable);
          option.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
        });
      });
    }

    function showErrorMessage(message) {
      let errorEl = root.querySelector('.qlf-bundle-builder__error');
      if (!errorEl) {
        errorEl = document.createElement('p');
        errorEl.className = 'qlf-bundle-builder__error';
        submitButton.parentElement.insertAdjacentElement('afterend', errorEl);
      }
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearErrorMessage() {
      const errorEl = root.querySelector('.qlf-bundle-builder__error');
      if (errorEl) {
        errorEl.hidden = true;
      }
    }

    function updateButtonState() {
      const isComplete = isCompleteSelection();
      const isSoldOut = !isComplete && (!parentVariantAvailable || hasBlockedGroups);

      submitButton.disabled = state.submitting || !isComplete;
      submitButton.classList.toggle('loading', state.submitting);

      if (submitButtonText) {
        if (isComplete) {
          // Bei Staffelbundles darf die erreichte Staffel den Button beschriften.
          // Diese Stelle schreibt zuletzt — ohne sie wuerde syncTieredButton() im
          // Snippet nach dem Bestaetigen wieder ueberschrieben.
          if (tiered) {
            const tieredQuantity = totalTieredQuantity(getTieredComponents());
            setTierText(
              submitButtonText,
              tieredButtonLabel(
                tiered,
                tieredQuantity,
                labels.button,
                incentiveState(incentiveList, tieredQuantity)
              )
            );
          } else {
            submitButtonText.textContent = labels.button;
          }
        } else if (isSoldOut) {
          submitButtonText.textContent = labels.soldOut;
        } else {
          submitButtonText.textContent = labels.incomplete;
        }
      }
    }

    function isCompleteSelection() {
      if (!parentVariantAvailable || hasBlockedGroups) {
        return false;
      }

      if (tiered) {
        // Staffelbundles haben keine Slots: die Gesamtmenge entscheidet.
        const quantity = totalTieredQuantity(getTieredComponents());
        return quantity >= tiered.min && (tiered.max === 0 || quantity <= tiered.max);
      }

      const selectedVariantIds = getSelectedVariantIds();

      if (
        selectedVariantIds.length === 0 ||
        selectedVariantIds.some((variantId) => variantId === '')
      ) {
        return false;
      }

      if (!allowDuplicates && new Set(selectedVariantIds).size !== selectedVariantIds.length) {
        return false;
      }

      return true;
    }

    function getSelectedVariantIds() {
      return slots.map((slot) => getSlotValue(slot));
    }

    function getSlotValue(slot) {
      const input = getSlotInput(slot);
      return input ? input.value.trim() : '';
    }

    function getTieredComponents() {
      return parseComponentString(componentsInput ? componentsInput.value : '');
    }

    function buildFixedProperties(selectedVariantIds) {
      return {
        _qlf_bundle_offer_id: offerId,
        _qlf_bundle_free_shipping: freeShipping ? 'true' : 'false',
        ...(freeShipping && freeShippingMin
          ? { _qlf_bundle_free_shipping_min: freeShippingMin }
          : {}),
        _qlf_bundle_name: bundleName,
        _qlf_bundle_image: bundleImage,
        _qlf_bundle_item_count: String(selectedVariantIds.length),
        _qlf_bundle_price: bundlePrice,
        _qlf_bundle_compare_at_price: bundleCompareAtPrice,
        _qlf_bundle_header_variant_id: String(selectedVariantIds[0] || ''),
        _qlf_bundle_components: JSON.stringify(selectedVariantIds),
        _Details: buildBundleDetails(selectedVariantIds)
      };
    }

    function buildTieredProperties(components) {
      const quantity = totalTieredQuantity(components);
      const unitPrice = tierUnitPrice(tiered, quantity);
      // Streichpreis wie im Popup: der Compare-at der Parent-Variante deckt die
      // Mindestmenge ab, jedes weitere Stueck zum Basis-Stueckpreis obendrauf.
      const compareAtTotal = parseFloat(bundleCompareAtPrice) || 0;
      const extraQty = quantity > tiered.min ? quantity - tiered.min : 0;
      // Wert der freigeschalteten Goodies, den renderTiered im Popup an den Root
      // geschrieben hat. Fehlt er - keine Goodiebox, Popup nie gerechnet -, bleibt
      // es beim reinen Produktwert. Ohne die in der App geschaltete Kopplung an die
      // Incentives schreibt renderTiered dort 0: dann gilt allein der Streichpreis
      // aus Shopify, im Warenkorb wie im Popup.
      const goodieBonus = parseFloat(root.dataset.goodieBonus) || 0;
      const refTotal =
        (compareAtTotal > 0
          ? compareAtTotal + extraQty * tiered.basePrice
          : tiered.basePrice * quantity) + goodieBonus;
      // Kompaktformat: die Cart-Transform-Function liest "id:menge,..." direkt.
      const compact = components
        .map(function (component) {
          return component.id + ':' + component.quantity;
        })
        .join(',');

      return {
        _qlf_bundle_offer_id: offerId,
        _qlf_bundle_free_shipping: freeShipping ? 'true' : 'false',
        ...(freeShipping && freeShippingMin
          ? { _qlf_bundle_free_shipping_min: freeShippingMin }
          : {}),
        _qlf_bundle_name: bundleName,
        _qlf_bundle_image: bundleImage,
        _qlf_bundle_item_count: String(quantity),
        _qlf_bundle_price: (unitPrice * quantity).toFixed(2),
        _qlf_bundle_compare_at_price:
          refTotal > unitPrice * quantity ? refTotal.toFixed(2) : bundleCompareAtPrice,
        _qlf_bundle_header_variant_id: String((components[0] && components[0].id) || ''),
        _qlf_bundle_components: compact,
        _Details: compact
      };
    }

    async function addBundleToCart() {
      if (!isCompleteSelection() || state.submitting) {
        return;
      }

      state.submitting = true;
      updateButtonState();

      try {
        const properties = tiered
          ? buildTieredProperties(getTieredComponents())
          : buildFixedProperties(getSelectedVariantIds());
        const response = await fetch(getCartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: parentVariantId,
                quantity: 1,
                properties: properties
              }
            ]
          })
        });

        if (!response.ok) {
          const errorBody = await response.json().catch(() => null);
          let errorMessage =
            (errorBody && errorBody.description) ||
            'Ein Fehler ist aufgetreten. Bitte versuche es erneut.';

          if (response.status === 422 && sectionId) {
            const refreshedBuilder = await refreshBuilderMarkup(root).catch(() => null);
            if (refreshedBuilder && refreshedBuilder !== root) {
              errorMessage = 'Das Bundle wurde aktualisiert. Bitte waehle deine Optionen erneut.';
            }
          }

          console.error('[Bundle] Cart add failed:', response.status, JSON.stringify(errorBody));
          showErrorMessage(errorMessage);
          throw new Error('cart_add_failed');
        }

        await response.json();
        clearErrorMessage();

        if (discountCode) {
          try {
            await applyDiscountCode(discountCode);
          } catch (discountError) {
            console.warn('[Bundle] Discount code could not be applied:', discountError);
          }
        }

        if (redirectToCheckout) {
          window.location.href = '/checkout';
          return;
        }

        if (redirectToCart) {
          window.location.href = '/cart';
          return;
        }

        refreshCartUi();
      } catch (error) {
        console.error('[Bundle] Add to cart failed:', error);
      } finally {
        state.submitting = false;
        updateButtonState();
      }
    }
  }

  function closeAllDropdowns(root, excludeList) {
    root.querySelectorAll('[data-list].visible').forEach(function (list) {
      if (excludeList && list === excludeList) {
        return;
      }

      list.classList.remove('visible');

      const trigger = list.parentElement && list.parentElement.querySelector('[data-trigger]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function getSlotInput(slot) {
    return slot ? slot.querySelector('.qlf-bundle-builder__input') : null;
  }

  async function refreshBuilderMarkup(builder) {
    if (!builder) {
      return builder;
    }

    const sectionId = (builder.dataset.sectionId || '').trim();
    const productUrl = (builder.dataset.productUrl || window.location.pathname || '').trim();
    const parentVariantId = (builder.dataset.parentVariantId || '').trim();

    if (!sectionId || !productUrl || !parentVariantId) {
      return builder;
    }

    const destination = document.getElementById('qlf-bundle-builder-' + sectionId);
    if (!destination) {
      return builder;
    }

    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('variant', parentVariantId);
    url.searchParams.set('section_id', sectionId);

    const response = await fetch(url.toString(), {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error('bundle_markup_refresh_failed');
    }

    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const source = html.getElementById('qlf-bundle-builder-' + sectionId);

    if (!source) {
      return builder;
    }

    if (source.innerHTML !== destination.innerHTML) {
      destination.innerHTML = source.innerHTML;
    }

    const nextBuilder = destination.querySelector('.qlf-bundle-builder');
    return nextBuilder || builder;
  }

  // --- Staffelrabatt-Helfer -------------------------------------------------

  function readTieredConfig(root) {
    if (!root || root.dataset.bundleMode !== 'tiered') {
      return null;
    }

    let tiers = [];
    try {
      tiers = JSON.parse(root.dataset.tieredTiers || '[]');
    } catch (error) {
      return null;
    }

    const normalized = (Array.isArray(tiers) ? tiers : [])
      .map(function (tier) {
        return {
          minQuantity: parseInt(tier && tier.minQuantity, 10),
          unitPrice: parseFloat(tier && tier.unitPrice),
          discountPercent: parseFloat(tier && tier.discountPercent) || 0,
          // Beschriftung des Warenkorb-Buttons ab der Mindestmenge. Die uebrigen
          // Werbetexte braucht das Asset nicht — sie stehen nur im Popup.
          labelButtonPage: (tier && tier.labelButtonPage) || ''
        };
      })
      .filter(function (tier) {
        return tier.minQuantity >= 1 && isFinite(tier.unitPrice) && tier.unitPrice >= 0;
      })
      .sort(function (a, b) {
        return a.minQuantity - b.minQuantity;
      });

    if (normalized.length === 0) {
      return null;
    }

    const min = parseInt(root.dataset.tieredMin, 10);
    const max = parseInt(root.dataset.tieredMax, 10);

    return {
      min: min >= 1 ? min : 1,
      max: max >= 1 ? max : 0,
      basePrice: parseFloat(root.dataset.tieredBasePrice) || 0,
      tiers: normalized
    };
  }

  function parseComponentString(value) {
    const raw = (value || '').trim();
    if (raw === '') {
      return [];
    }

    const components = [];
    raw.split(',').forEach(function (part) {
      const pair = part.split(':');
      const id = (pair[0] || '').trim();
      const quantity = parseInt(pair[1], 10);

      if (id === '' || !(quantity > 0)) {
        return;
      }

      const existing = components.find(function (component) {
        return component.id === id;
      });

      if (existing) {
        existing.quantity += quantity;
      } else {
        components.push({ id: id, quantity: quantity });
      }
    });

    return components;
  }

  function totalTieredQuantity(components) {
    return components.reduce(function (total, component) {
      return total + component.quantity;
    }, 0);
  }

  // Hoechste Staffel, deren Mindestmenge erreicht ist — sonst die niedrigste.
  function tierFor(tiered, quantity) {
    let match = tiered.tiers[0];
    tiered.tiers.forEach(function (tier) {
      if (quantity >= tier.minQuantity) {
        match = tier;
      }
    });
    return match;
  }

  // Beschriftung des Warenkorb-Buttons ab der Mindestmenge. {qty} ist die AUSGEWAEHLTE
  // Menge, {percent} der Rabatt der erreichten Staffel. Ohne gepflegten Text bleibt die
  // heutige Beschriftung. Dieselbe Logik steht inline in snippets/qlf-bundle-builder.liquid
  // (tierButtonText) — inline und statisch koennen keinen Code teilen.
  // Zugaben aus data-incentive-list. Muss zu parseIncentiveList() in
  // snippets/qlf-bundle-builder.liquid passen — inline und statisch koennen keinen
  // Code teilen, und beide Stellen beschriften denselben Button. Deshalb zaehlt auch
  // hier ein abweichender Popup-Wert, wenn die App einen gepflegt hat.
  // Gegenstueck zu incentiveListMin() im Snippet: der Popup-Wert schlaegt die echte
  // Stufe, auch wenn er 0 ist ("sofort sichtbar").
  function incentiveListMin(entry) {
    const raw =
      entry && entry.popupMinQuantity != null ? entry.popupMinQuantity : entry && entry.minQuantity;
    const min = parseInt(raw, 10);
    return isNaN(min) ? 1 : Math.max(0, min);
  }

  function readIncentiveList(root) {
    let parsed;
    try {
      parsed = JSON.parse((root && root.dataset.incentiveList) || '[]');
    } catch (error) {
      return [];
    }
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed
      .map(function (entry) {
        return {
          name: ((entry && (entry.displayTitle || entry.productTitle)) || '').trim(),
          min: incentiveListMin(entry)
        };
      })
      .sort(function (a, b) {
        return a.min - b.min;
      });
  }

  // Stand der Zugaben bei dieser Menge: wie viele liegen bei, welche kommt als
  // naechstes, wie viele Stueck fehlen dafuer. Gegenstueck zu giftState() im Snippet.
  function incentiveState(list, quantity) {
    let unlocked = 0;
    let next = null;
    (list || []).forEach(function (entry) {
      if (entry.min <= quantity) {
        unlocked += 1;
      } else if (!next) {
        next = entry;
      }
    });
    return {
      gifts: unlocked,
      name: next ? next.name : '',
      missing: next ? next.min - quantity : 0
    };
  }

  // Staffeltexte aus der App duerfen Markup und Zeilenumbrueche tragen (Admin-gepflegt,
  // dieselbe Vertrauensstufe wie das Popup-Custom-Liquid). Gegenstueck zu setTierText()
  // in snippets/qlf-bundle-builder.liquid - inline und statisch koennen keinen Code
  // teilen, und beide Stellen beschriften denselben Button.
  function setTierText(el, text) {
    if (!el) return;
    el.innerHTML = String(text == null ? '' : text).replace(/\r\n|\r|\n/g, '<br>');
  }

  function tieredButtonLabel(tiered, quantity, fallback, gift) {
    const tier = tierFor(tiered, quantity);
    const raw = ((tier && tier.labelButtonPage) || '').trim();
    if (!raw) {
      return fallback;
    }
    let percent = tier.discountPercent;
    if (!percent && tiered.basePrice > tier.unitPrice) {
      percent = ((tiered.basePrice - tier.unitPrice) / tiered.basePrice) * 100;
    }
    const g = gift || { gifts: 0, name: '', missing: 0 };
    return raw
      .replace(/\{qty\}/gi, quantity)
      .replace(/\{percent\}/gi, Math.round(percent))
      .replace(/\{gifts\}/gi, g.gifts)
      .replace(/\{giftname\}/gi, g.name)
      .replace(/\{giftcount\}/gi, g.missing);
  }

  function tierUnitPrice(tiered, quantity) {
    let match = tiered.tiers[0];
    tiered.tiers.forEach(function (tier) {
      if (quantity >= tier.minQuantity) {
        match = tier;
      }
    });
    return match ? match.unitPrice : 0;
  }

  function buildBundleDetails(selectedVariantIds) {
    const counts = selectedVariantIds.reduce((accumulator, variantId) => {
      if (!variantId) {
        return accumulator;
      }

      accumulator[variantId] = (accumulator[variantId] || 0) + 1;
      return accumulator;
    }, {});

    return Object.entries(counts)
      .map(function ([variantId, quantity]) {
        return variantId + ':' + quantity;
      })
      .join(',');
  }

  function trackBundleView(offerId, trackingUrl, options) {
    if (!trackingUrl || shouldSkipBundleViewTracking(options)) {
      return;
    }

    const requestKey = [
      offerId || '',
      trackingUrl,
      window.location.pathname,
      window.location.search
    ].join(':');

    if (bundleViewTrackCache.has(requestKey)) {
      return;
    }

    let storageKey = '';

    try {
      storageKey = [
        'qlf_bundle_view',
        offerId || trackingUrl,
        window.location.pathname,
        window.location.search
      ].join(':');

      if (window.sessionStorage && window.sessionStorage.getItem(storageKey) === '1') {
        bundleViewTrackCache.add(requestKey);
        return;
      }
    } catch (error) {
      storageKey = '';
    }

    bundleViewTrackCache.add(requestKey);

    const tracker = new Image(1, 1);
    tracker.decoding = 'async';
    tracker.referrerPolicy = 'strict-origin-when-cross-origin';
    tracker.src = trackingUrl;

    window.__qlfBundleViewTrackers = window.__qlfBundleViewTrackers || [];
    window.__qlfBundleViewTrackers.push(tracker);

    if (storageKey !== '') {
      tracker.onload = tracker.onerror = function () {
        try {
          window.sessionStorage.setItem(storageKey, '1');
        } catch (error) {
          // Ignore unavailable storage.
        }
      };
    }
  }

  function shouldSkipBundleViewTracking(options) {
    if (options && options.disabled) {
      return true;
    }

    if (window.Shopify && window.Shopify.designMode) {
      return true;
    }

    const hostname = (window.location.hostname || '').toLowerCase();
    if (hostname === 'shopifypreview.com' || hostname.endsWith('.shopifypreview.com')) {
      return true;
    }

    try {
      const params = new URLSearchParams(window.location.search || '');
      return params.has('preview_key') || params.has('preview_theme_id');
    } catch (error) {
      return false;
    }
  }

  async function applyDiscountCode(discountCode) {
    const response = await fetch('/discount/' + encodeURIComponent(discountCode), {
      method: 'GET'
    });

    if (!response.ok) {
      throw new Error('discount_apply_failed');
    }
  }

  function emitCartEvent(eventName, detail) {
    document.dispatchEvent(
      new CustomEvent(eventName, {
        bubbles: true,
        detail: detail || {}
      })
    );
  }

  function getCartAddUrl() {
    const rootUrl = window.Shopify?.routes?.root || '/';
    return rootUrl.replace(/\/$/, '') + '/cart/add.js';
  }

  function closeActiveProductDrawer() {
    const drawer = document.getElementById('Product-Drawer');
    const isDrawerActive =
      drawer &&
      drawer.classList.contains('active') &&
      document.body.classList.contains('open-cc--product');

    if (!isDrawerActive) {
      return false;
    }

    const closeButton = drawer.querySelector('.side-panel-close');
    if (closeButton instanceof HTMLElement) {
      closeButton.click();
      return true;
    }

    drawer.classList.remove('active');
    document.body.classList.remove('open-cc--product');
    window.setTimeout(function () {
      const drawerContent = drawer.querySelector('#Product-Drawer-Content');
      if (drawerContent) {
        drawerContent.innerHTML = '';
      }
    }, 260);

    return true;
  }

  function refreshCartUi() {
    emitCartEvent('cart:refresh');

    if (closeActiveProductDrawer()) {
      window.setTimeout(function () {
        emitCartEvent('cart:open');
      }, 260);
      return;
    }

    emitCartEvent('cart:open');
  }

  function initializeQuickAddButtons(context) {
    const scope = context instanceof HTMLElement ? context : document;
    scope
      .querySelectorAll('.qlf-bundle-quick-add:not([data-initialized])')
      .forEach(function (button) {
        button.dataset.initialized = 'true';
        button.addEventListener('click', handleBundleQuickAdd);
      });
  }

  async function handleBundleQuickAdd() {
    const button = this;
    if (button.disabled || button.dataset.submitting === 'true') return;

    const parentVariantId = Number(button.dataset.bundleParentVariantId || '0');
    const offerId = (button.dataset.bundleOfferId || '').trim();
    const freeShipping = button.dataset.bundleFreeShipping === 'true';
    const freeShippingMin = (button.dataset.bundleFreeShippingMin || '').trim();
    const slotIdsRaw = (button.dataset.bundleSlotIds || '').trim();
    const discountCode = (button.dataset.bundleDiscountCode || '').trim();
    const bundleName = (button.dataset.bundleName || '').trim();
    const bundleImage = (button.dataset.bundleImage || '').trim();
    const bundlePrice = (button.dataset.bundlePrice || '').trim();
    const bundleCompareAtPrice = (button.dataset.bundleCompareAtPrice || '').trim();
    if (!parentVariantId || !slotIdsRaw) return;

    const selectedVariantIds = slotIdsRaw.split(',').filter(Boolean);

    button.dataset.submitting = 'true';
    button.classList.add('loading');
    const textEl = button.querySelector('.single-add-to-cart-button--text');
    if (textEl) textEl.style.display = 'none';

    try {
      const response = await fetch(getCartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: parentVariantId,
              quantity: 1,
              properties: {
                _qlf_bundle_offer_id: offerId,
                _qlf_bundle_free_shipping: freeShipping ? 'true' : 'false',
                ...(freeShipping && freeShippingMin
                  ? { _qlf_bundle_free_shipping_min: freeShippingMin }
                  : {}),
                _qlf_bundle_name: bundleName,
                _qlf_bundle_image: bundleImage,
                _qlf_bundle_item_count: String(selectedVariantIds.length),
                _qlf_bundle_price: bundlePrice,
                _qlf_bundle_compare_at_price: bundleCompareAtPrice,
                _qlf_bundle_header_variant_id: String(selectedVariantIds[0] || ''),
                _qlf_bundle_components: JSON.stringify(selectedVariantIds),
                _Details: buildBundleDetails(selectedVariantIds)
              }
            }
          ]
        })
      });

      if (!response.ok) {
        const errorBody = await response.json().catch(() => null);
        const errorMessage =
          (errorBody && errorBody.description) ||
          'Ein Fehler ist aufgetreten. Bitte versuche es erneut.';
        console.error(
          '[Bundle QuickAdd] Cart add failed:',
          response.status,
          JSON.stringify(errorBody)
        );
        let errorEl =
          button.parentElement &&
          button.parentElement.querySelector('.qlf-bundle-quick-add__error');
        if (!errorEl) {
          errorEl = document.createElement('p');
          errorEl.className = 'qlf-bundle-quick-add__error qlf-bundle-builder__error';
          button.insertAdjacentElement('afterend', errorEl);
        }
        errorEl.textContent = errorMessage;
        errorEl.hidden = false;
        return;
      }

      await response.json();

      if (discountCode) {
        await applyDiscountCode(discountCode).catch((e) =>
          console.warn('[Bundle QuickAdd] Discount failed:', e)
        );
      }

      refreshCartUi();
    } catch (error) {
      console.error('[Bundle QuickAdd] Failed:', error);
    } finally {
      button.dataset.submitting = 'false';
      button.classList.remove('loading');
      if (textEl) textEl.style.display = '';
    }
  }

  document.addEventListener('click', function (event) {
    document.querySelectorAll('.qlf-bundle-builder').forEach(function (builder) {
      if (!builder.contains(event.target)) {
        closeAllDropdowns(builder);
      }
    });
  });

  if (document.readyState !== 'loading') {
    initializeAll(document);
    initializeQuickAddButtons(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
      initializeQuickAddButtons(document);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
    initializeQuickAddButtons(event.target);
  });

  document.addEventListener('product:variant-rendered', function () {
    initializeAll(document);
  });

  document.addEventListener('quick-view:open', function () {
    initializeAll(document);
    initializeQuickAddButtons(document);
  });
})();
